/* 詳細画面 申込人 */
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ReactDOM from 'react-dom';
import MaskImage from './MaskImage';
import { useCallApi } from '../../hooks/CallApi';
import useFetchReceptionData from '../../hooks/FetchReceptionData';
import PreExaminationInput from './PreExaminationInput';
import PreExaminationConfirm from './PreExaminationConfirm';
import PreExaminationFinish from './PreExaminationFinish';
import ExaminationInput from './ExaminationInput';
import ExaminationFileUpload from './ExaminationFileUpload';
import ExaminationFinalConfirm from './ExaminationFinalConfirm';
import ExaminationChangeInput from './ExaminationChangeInput';
import ContractContentConfirm from './ContractContentConfirm';
import BorrowingConsultationInput from './BorrowingConsultationInput';
import BorrowingConsultationConfirm from './BorrowingConsultationConfirm';
import BorrowingConsultationFinish from './BorrowingConsultationFinish';
import ConfirmationOfBorrowingConsultationResults from './ConfirmationOfBorrowingConsultationResults';
import PreliminaryExaminationResultConfirmation from './PreliminaryExaminationResultConfirmation';
import ConfirmationOfMainExaminationResults from './ConfirmationOfMainExaminationResults';
import ContractApplicationConfirmation from './ContractApplicationConfirmation';
import ContractApplicationFinish from './ContractApplicationFinish';
import ExaminationComplete from './ExaminationComplete';
import BorrowingConsultationReferencePreview from './BorrowingConsultationReferencePreview';
import PreExaminationReferencePreview from './PreExaminationReferencePreview';
import ContractApplicationDeclined from './ContractApplicationDeclined';
import BorrowingApplicationConfirmation from './BorrowingApplicationConfirmation';
import BorrowingConsultationChangeInput from './BorrowingConsultationChangeInput';
import BorrowingConsultationChangeConfirm from './BorrowingConsultationChangeConfirm';
import BorrowingConsultationChangeFinish from './BorrowingConsultationChangeFinish';
import PreliminaryExaminationResultConfirmationDisapproval from './PreliminaryExaminationResultConfirmationDisapproval';
import ScrollTop from '../../ScrollTop';
import DeclineLoanApplication from './DeclineLoanApplication';
import SignatureComplete from './SignatureComplete';
import AfterLoanApplication from './AfterLoanApplication';
import BorrowingConsultationPreview from './BorrowingConsultationPreview';
import {
  KWANKGM02020A01_Autodisplay,
  KWANKGM02020A01_Validate,
  KWANKGM02020A01,
  KWANKGM02040A01,
  KWANKGM02040A02,
  KWANKGM03020A01_Autodisplay,
  KWANKGM03020A01_Validate,
  KWANKGM03020A01,
  KWANKGM04010A01,
  KWANKGM04030A03_Autodisplay,
  KWANKGM04030A03_Validate,
  KWANKGM04030A03,
  KWANKGM04030A04,
  KWANKGM04030A05,
  KWANKGM03040A01,
  KWANKGM04080A01,
  KWANKGM04080A02,
  KDANKGM05010A01,
  KDANKGM05010A02,
  KWANKGM02020A02,
} from '../../const/api_modules';
import { FixedValuesContext } from '../../context/FixedValues';
import useLazyLoad from '../../hooks/LazyLoad';
import { hasErrorMessage } from '../../Common';

const App: React.FC = () => {
  // ローディング画面制御
  const [is_loading, setIsLoading] = useState(false);
  const {
    // ヘッダ
    label,
    guide_text,
    step_navigation,
    display_reception_cd,
    display_status,
    // 詳細画面情報
    parent_shelfs,
    child_shelfs,
    contents,
    is_bank_exists,
    is_desired_bank_exists,
    is_ja_exists,
    is_mypage_ja,
    // 固定パラメータ
    status_name,
    status_code,
    loan_type,
    reception_id,
    reception_cd,
    reception_sub_cd,
    ident_lv1_cd,
    ident_lv2_cd,
    ident_lv3_cd,
    ja_name,
    opened_mypage,
    is_staff,
    applied,
    is_change,
    has_debtor,
    is_disagree,
    change_request_message,
    guarantors_num,
    sign_info,
    agreement_info,
    is_signed,
    agreements,
    guarantor_info,
    review_approval_status,
    review_approval_status_name,
    review_message,
    contract_info,
    is_checked_contract_document,
    has_loan_approval,
    is_implement_online_identification,
    online_identification_modal_open,
    is_agricultural_funds_kinds_agricultural_fund,
    is_agricultural_funds_kinds_modernization_fund,
    is_secured,
    is_unsecured,
    is_agricultural_modernization_funds,
    // ファイルアップローダ
    shelf_info_a,
    shelf_info_b,
    shelf_info_c,
    shelf_info_d,
    shelf_info_e,
    shelf_info_f,
    shelf_info_g,
    shelf_info_h,
    shelf_info_i,
    shelf_info_j,
    shelf_info_k,
    shelf_info_aa,
    shelf_info_ab,
    shelf_info_ac,
    shelf_info_ad,
    shelf_info_ae,
    shelf_info_af,
    shelf_info_ag,
    shelf_info_ah,
    shelf_info_ai,
    shelf_info_aj,
    shelf_info_ak,
    shelf_info_al,
    shelf_info_am,
    shelf_info_an,
    shelf_info_ao,
    shelf_info_ap,
    shelf_info_aq,
    shelf_info_ar,
    shelf_info_as,
    shelf_info_at,
    shelf_info_au,
    shelf_info_av,
    shelf_info_aw,
    shelf_info_ax,
    shelf_info_ay,
    shelf_info_az,
    shelf_info_ba,
    shelf_info_bb,
    shelf_info_bc,
    shelf_info_bd,
    shelf_info_be,
    shelf_info_bf,
    shelf_info_bg,
    shelf_info_bh,
    shelf_info_bi,
    // お客様へのお知らせ
    info_notice_contract_confirm,
    // 辞退ボタンの活性フラグ
    is_active_decline_btn,
    is_corporate_user,
    is_signer,
    // ディスパッチ
    setParentShelfs,
    setChildShelfs,
    setContents,
    setShelfInfoA,
    setShelfInfoB,
    setShelfInfoC,
    setShelfInfoD,
    setShelfInfoE,
    setShelfInfoF,
    setShelfInfoG,
    setShelfInfoH,
    setShelfInfoI,
    setShelfInfoJ,
    setShelfInfoK,
    setShelfInfoAA,
    setShelfInfoAB,
    setShelfInfoAC,
    setShelfInfoAD,
    setShelfInfoAE,
    setShelfInfoAF,
    setShelfInfoAG,
    setShelfInfoAH,
    setShelfInfoAI,
    setShelfInfoAJ,
    setShelfInfoAK,
    setShelfInfoAL,
    setShelfInfoAM,
    setShelfInfoAN,
    setShelfInfoAO,
    setShelfInfoAP,
    setShelfInfoAQ,
    setShelfInfoAR,
    setShelfInfoAS,
    setShelfInfoAT,
    setShelfInfoAU,
    setShelfInfoAV,
    setShelfInfoAW,
    setShelfInfoAX,
    setShelfInfoAY,
    setShelfInfoAZ,
    setShelfInfoBA,
    setShelfInfoBB,
    setShelfInfoBC,
    setShelfInfoBD,
    setShelfInfoBE,
    setShelfInfoBF,
    setShelfInfoBG,
    setShelfInfoBH,
    setShelfInfoBI,
    setDisplayStatus,
    setIsImplementOnlineIdentification,
    // 関数
    moveStepNav,
    setOnlineIdentificationModalOpen,
  } = useFetchReceptionData(setIsLoading);

  // API呼び出し処理
  const { setShowErrorNav, show_error_nav, requestModule, api_response_detail } = useCallApi(
    child_shelfs,
    contents,
    setContents,
    setChildShelfs,
    reception_id,
    reception_cd,
    status_code,
    is_staff,
    setIsLoading,
    guarantor_info,
    setOnlineIdentificationModalOpen
  );

  // 書類画像の遅延ロード
  useLazyLoad(
    shelf_info_a,
    shelf_info_b,
    shelf_info_c,
    shelf_info_d,
    shelf_info_e,
    shelf_info_f,
    shelf_info_g,
    shelf_info_h,
    shelf_info_i,
    shelf_info_j,
    shelf_info_k,
    shelf_info_aa,
    shelf_info_ab,
    shelf_info_ac,
    shelf_info_ad,
    shelf_info_ae,
    shelf_info_af,
    shelf_info_ag,
    shelf_info_ah,
    shelf_info_ai,
    shelf_info_aj,
    shelf_info_ak,
    shelf_info_al,
    shelf_info_am,
    shelf_info_an,
    shelf_info_ao,
    shelf_info_ap,
    shelf_info_aq,
    shelf_info_ar,
    shelf_info_as,
    shelf_info_at,
    shelf_info_au,
    shelf_info_av,
    shelf_info_aw,
    shelf_info_ax,
    shelf_info_ay,
    shelf_info_az,
    shelf_info_ba,
    shelf_info_bb,
    shelf_info_bc,
    shelf_info_bd,
    shelf_info_be,
    shelf_info_bf,
    shelf_info_bg,
    shelf_info_bh,
    shelf_info_bi,
    setShelfInfoA,
    setShelfInfoB,
    setShelfInfoC,
    setShelfInfoD,
    setShelfInfoE,
    setShelfInfoF,
    setShelfInfoG,
    setShelfInfoH,
    setShelfInfoI,
    setShelfInfoJ,
    setShelfInfoK,
    setShelfInfoAA,
    setShelfInfoAB,
    setShelfInfoAC,
    setShelfInfoAD,
    setShelfInfoAE,
    setShelfInfoAF,
    setShelfInfoAG,
    setShelfInfoAH,
    setShelfInfoAI,
    setShelfInfoAJ,
    setShelfInfoAK,
    setShelfInfoAL,
    setShelfInfoAM,
    setShelfInfoAN,
    setShelfInfoAO,
    setShelfInfoAP,
    setShelfInfoAQ,
    setShelfInfoAR,
    setShelfInfoAS,
    setShelfInfoAT,
    setShelfInfoAU,
    setShelfInfoAV,
    setShelfInfoAW,
    setShelfInfoAX,
    setShelfInfoAY,
    setShelfInfoAZ,
    setShelfInfoBA,
    setShelfInfoBB,
    setShelfInfoBC,
    setShelfInfoBD,
    setShelfInfoBE,
    setShelfInfoBF,
    setShelfInfoBG,
    setShelfInfoBH,
    setShelfInfoBI,
    is_loading,
    status_code
  );

  // エラーナビゲーション制御
  const [has_valid_error, setHasValidError] = useState(false);

  useEffect(() => {
    setHasValidError(hasErrorMessage(contents));
  }, [contents]);

  return (
    <Router>
      {/* TODO sakuma 固定値はすべてこちらのContextを見るように修正する */}
      <FixedValuesContext.Provider
        value={{
          has_loan_approval: has_loan_approval,
          has_review_approval_status: review_approval_status,
        }}
      >
        <ScrollTop setChildShelfs={setChildShelfs} />
        <Switch>
          {/* KWANKGM02010_借入相談入力 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(1000|1100)">
            <BorrowingConsultationInput
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={false} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_staff={is_staff}
              moveNextStep={() => moveStepNav(2)}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              display_status={display_status}
              show_error_nav={has_valid_error || show_error_nav}
              requestModule={() => requestModule(KWANKGM02020A01_Validate)}
              requestModuleAutodisplay={() => requestModule(KWANKGM02020A01_Autodisplay)}
              callApi={requestModule}
              guarantor_info={guarantor_info}
              is_bank_exists={is_bank_exists}
              is_desired_bank_exists={is_desired_bank_exists}
              is_ja_exists={is_ja_exists}
              is_mypage_ja={is_mypage_ja}
              setShowErrorNav={setShowErrorNav}
            />
          </Route>
          {/* KWANKGM02020_借入相談入力確認 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(1000|1100)/Confirm">
            <BorrowingConsultationConfirm
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_staff={is_staff}
              movePrevStep={() => moveStepNav(1)}
              moveNextStep={() => moveStepNav(3)}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              display_status={display_status}
              show_error_nav={has_valid_error || show_error_nav}
              requestModule={() => requestModule(KWANKGM02020A01)}
              callApi={requestModule}
              guarantor_info={guarantor_info}
            />
          </Route>
          {/* KWANKGM02030_借入相談受付完了 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(1000|1100)/finish">
            <BorrowingConsultationFinish
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              is_staff={is_staff}
              opened_mypage={opened_mypage}
              is_loading={is_loading}
              ja_name={ja_name}
            />
          </Route>
          {/* 借入相談変更中（入力） */}
          <Route exact path="/reception/:reception_cd/:reception_id/1200">
            <BorrowingConsultationChangeInput
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={false} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_staff={is_staff}
              moveNextStep={() => moveStepNav(2)}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              display_status={display_status}
              show_error_nav={has_valid_error || show_error_nav}
              requestModule={() => requestModule(KWANKGM02020A01_Validate)}
              requestModuleAutodisplay={() => requestModule(KWANKGM02020A01_Autodisplay)}
              callApi={requestModule}
              change_request_message={change_request_message}
              guarantor_info={guarantor_info}
              is_bank_exists={is_bank_exists}
              is_desired_bank_exists={is_desired_bank_exists}
              is_ja_exists={is_ja_exists}
              is_mypage_ja={is_mypage_ja}
            />
          </Route>
          {/* 借入相談変更中（確認） */}
          <Route exact path="/reception/:reception_cd/:reception_id/1200/Confirm">
            <BorrowingConsultationChangeConfirm
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_staff={is_staff}
              movePrevStep={() => moveStepNav(1)}
              moveNextStep={() => moveStepNav(3)}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              display_status={display_status}
              show_error_nav={has_valid_error || show_error_nav}
              requestModule={() => requestModule(KWANKGM02020A01)}
              callApi={requestModule}
              guarantor_info={guarantor_info}
            />
          </Route>
          {/* 借入相談変更中（完了） */}
          <Route exact path="/reception/:reception_cd/:reception_id/1200/finish">
            <BorrowingConsultationChangeFinish
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              is_staff={is_staff}
              opened_mypage={opened_mypage}
            />
          </Route>
          {/* KWANKGM02020_借入相談入力確認 参照画面 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(1250|1260)">
            <BorrowingConsultationPreview
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              display_status={display_status}
              show_error_nav={has_valid_error || show_error_nav}
              callApi={requestModule}
              guarantor_info={guarantor_info}
              has_debtor={has_debtor}
              agreement_info={agreement_info}
              handleClickChangeDetails={() => requestModule(KWANKGM02020A02)}
            />
          </Route>
          {/* KWANKGM02040_借入相談結果確認 */}
          <Route exact path="/reception/:reception_cd/:reception_id/1500">
            <ConfirmationOfBorrowingConsultationResults
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true}
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_staff={is_staff}
              opened_mypage={opened_mypage}
              moveNextStep={() => moveStepNav(2)}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              review_approval_status={review_approval_status}
              requestModule={() => requestModule(KWANKGM02040A01)}
              transitionModernizationFundsInputTypeSelect={() => requestModule(KWANKGM02040A02)}
              callApi={requestModule}
              guarantor_info={guarantor_info}
              is_agricultural_funds_kinds_agricultural_fund={
                is_agricultural_funds_kinds_agricultural_fund
              }
              is_agricultural_funds_kinds_modernization_fund={
                is_agricultural_funds_kinds_modernization_fund
              }
            />
          </Route>
          {/* KWANKGM03010_事前審査申込入力詳細 案件紐付からの手続き */}
          <Route exact path="/reception/:reception_cd/:reception_id/1600">
            <PreExaminationInput
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={false} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_staff={is_staff}
              opened_mypage={opened_mypage}
              moveNextStep={() => moveStepNav(2)}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              requestModule={() => requestModule(KWANKGM03020A01_Validate)}
              requestModuleAutodisplay={() => requestModule(KWANKGM03020A01_Autodisplay)}
              callApi={requestModule}
              guarantor_info={guarantor_info}
              is_bank_exists={is_bank_exists}
              is_desired_bank_exists={is_desired_bank_exists}
              is_ja_exists={is_ja_exists}
              is_mypage_ja={is_mypage_ja}
              setShowErrorNav={setShowErrorNav}
            />
          </Route>
          {/* KWANKGM03020_事前審査申込入力（確認） 案件紐付からの手続き */}
          <Route exact path="/reception/:reception_cd/:reception_id/1600/confirm">
            <PreExaminationConfirm
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_loading={is_loading}
              is_staff={is_staff}
              opened_mypage={opened_mypage}
              applied={applied}
              moveNextStep={() => moveStepNav(3)}
              movePrevStep={() => moveStepNav(1)}
              guarantors_num={guarantors_num}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              requestModule={() => requestModule(KWANKGM03020A01)}
              callApi={requestModule}
              guarantor_info={guarantor_info}
            />
          </Route>
          {/* KWANKGM03030_事前審査申込入力（受付完了） 案件紐付からの手続き */}
          <Route exact path="/reception/:reception_cd/:reception_id/1600/finish">
            <PreExaminationFinish
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              ja_name={ja_name}
              is_staff={is_staff}
              opened_mypage={opened_mypage}
              display_status={display_status}
            />
          </Route>
          {/* KWANKGM03010_事前審査申込入力詳細  通常版 */}
          <Route exact path="/reception/:reception_cd/:reception_id/1700">
            <PreExaminationInput
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={false} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_staff={is_staff}
              opened_mypage={opened_mypage}
              moveNextStep={() => moveStepNav(2)}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              requestModule={() => requestModule(KWANKGM03020A01_Validate)}
              requestModuleAutodisplay={() => requestModule(KWANKGM03020A01_Autodisplay)}
              callApi={requestModule}
              guarantor_info={guarantor_info}
              is_bank_exists={is_bank_exists}
              is_desired_bank_exists={is_desired_bank_exists}
              is_ja_exists={is_ja_exists}
              is_mypage_ja={is_mypage_ja}
              setShowErrorNav={setShowErrorNav}
            />
          </Route>
          {/* KWANKGM03020_事前審査申込入力（確認） 通常版 */}
          <Route exact path="/reception/:reception_cd/:reception_id/1700/confirm">
            <PreExaminationConfirm
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_loading={is_loading}
              is_staff={is_staff}
              opened_mypage={opened_mypage}
              applied={applied}
              moveNextStep={() => moveStepNav(3)}
              movePrevStep={() => moveStepNav(1)}
              guarantors_num={guarantors_num}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              requestModule={() => requestModule(KWANKGM03020A01)}
              callApi={requestModule}
              guarantor_info={guarantor_info}
            />
          </Route>
          {/* KWANKGM03030_事前審査申込入力（受付完了）  通常版 */}
          <Route exact path="/reception/:reception_cd/:reception_id/1700/finish">
            <PreExaminationFinish
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              ja_name={ja_name}
              is_staff={is_staff}
              opened_mypage={opened_mypage}
              display_status={false}
            />
          </Route>
          {/* 事前審査参照画面：1800, 1850, 1900, 1950 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(1800|1850|1900|1950)">
            <PreExaminationReferencePreview
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true}
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_loading={is_loading}
              is_staff={is_staff}
              guarantors_num={guarantors_num}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              callApi={requestModule}
              guarantor_info={guarantor_info}
            />
          </Route>
          {/* 事前審査結果確認 */}
          <Route exact path="/reception/:reception_cd/:reception_id/2000">
            <PreliminaryExaminationResultConfirmation
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={false} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              opened_mypage={opened_mypage}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              requestModule={() => requestModule(KWANKGM03040A01)}
              callApi={requestModule}
              guarantor_info={guarantor_info}
            />
          </Route>
          {/* KWANKGM04010_借入申込詳細 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(2100|2300)">
            <ExaminationInput
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={false} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_loading={is_loading}
              is_staff={is_staff}
              opened_mypage={opened_mypage}
              moveNextStep={() => moveStepNav(2)}
              tempSave={() => requestModule(KWANKGM04010A01)}
              guarantors_num={guarantors_num}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              validate={() => requestModule(KWANKGM04030A03_Validate)}
              requestModuleAutodisplay={() => requestModule(KWANKGM04030A03_Autodisplay)}
              callApi={requestModule}
              guarantor_info={guarantor_info}
              is_bank_exists={is_bank_exists}
              is_desired_bank_exists={is_desired_bank_exists}
              is_ja_exists={is_ja_exists}
              is_mypage_ja={is_mypage_ja}
              setShowErrorNav={setShowErrorNav}
              is_implement_online_identification={is_implement_online_identification}
              setIsImplementOnlineIdentification={setIsImplementOnlineIdentification}
              modal_open={online_identification_modal_open}
              setModalnOpen={setOnlineIdentificationModalOpen}
              is_corporate_user={is_corporate_user}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
            />
          </Route>
          {/* 借入申込変更（入力） */}
          <Route exact path="/reception/:reception_cd/:reception_id/2200">
            <ExaminationChangeInput
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={false} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              opened_mypage={opened_mypage}
              moveNextStep={() => moveStepNav(2)}
              tempSave={() => requestModule(KWANKGM04010A01)}
              validate={() => requestModule(KWANKGM04030A03_Validate)}
              requestModuleAutodisplay={() => requestModule(KWANKGM04030A03_Autodisplay)}
              change_request_message={change_request_message}
              guarantors_num={guarantors_num}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              callApi={requestModule}
              is_loading={is_loading}
              is_staff={is_staff}
              guarantor_info={guarantor_info}
              is_bank_exists={is_bank_exists}
              is_desired_bank_exists={is_desired_bank_exists}
              is_ja_exists={is_ja_exists}
              is_mypage_ja={is_mypage_ja}
              is_implement_online_identification={is_implement_online_identification}
              setIsImplementOnlineIdentification={setIsImplementOnlineIdentification}
              modal_open={online_identification_modal_open}
              setModalnOpen={setOnlineIdentificationModalOpen}
              is_corporate_user={is_corporate_user}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
            />
          </Route>
          {/* KWANKGM04020_借入申込書類提出, 借入申込内容変更（書類提出）画面 */}
          <Route path="/reception/:reception_cd/:reception_id/(2100|2200|2300)/upload">
            <ExaminationFileUpload
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
              guarantor_info={guarantor_info}
              reception_id={reception_id}
              status_code={status_code}
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              movePrevStep={() => moveStepNav(1)}
              moveNextStep={() => moveStepNav(3)}
              reception_sub_cd={reception_sub_cd}
              looks_inactive={false}
              guarantors_num={guarantors_num}
              display_status={display_status}
              is_change={is_change}
              loan_type={loan_type}
              is_secured={is_secured}
              is_unsecured={is_unsecured}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
            />
          </Route>
          {/* KWANKGM04030_借入申込入力（確認）, 借入申込内容変更（確認）画面 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(2100|2200|2300)/final_confirm">
            <ExaminationFinalConfirm
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              is_change={is_change}
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              is_loading={is_loading}
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              movePrevStep={() => moveStepNav(2)}
              moveNextStep={() => moveStepNav(4)}
              reception_sub_cd={reception_sub_cd}
              setDisplayStatus={flag => {
                setDisplayStatus(flag);
              }}
              handleClickTempSave={() => requestModule(KWANKGM04010A01)}
              handleClickChangeDetails={() => requestModule(KWANKGM04030A05)}
              handleClickDecline={() => requestModule(KWANKGM04030A04)}
              handleClickNext={() => requestModule(KWANKGM04030A03)}
              guarantors_num={guarantors_num}
              guarantor_info={guarantor_info}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              callApi={requestModule}
              is_secured={is_secured}
              is_unsecured={is_unsecured}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
            />
          </Route>
          {/* KWANKGM04040_借入申込入力（受付完了）, 借入申込内容変更（受付完了）画面 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(2100|2200|2300)/complete">
            <ExaminationComplete
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              is_loading={is_loading}
              guarantors_num={guarantors_num}
              display_status={display_status}
              is_change={is_change}
            />
          </Route>
          {/* 借入申込確認画面 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(2400|2500|2600|2700)">
            <BorrowingApplicationConfirmation
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              is_staff={is_staff}
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              reception_sub_cd={reception_sub_cd}
              agreement_info={agreement_info}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              has_debtor={has_debtor}
              handleClickDecline={() => requestModule(KWANKGM04030A04)}
              handleClickResendMail={() => {
                location.replace(
                  `${location.origin}${process.env.MIX_MOCK_URL}/applicant/mail_resend?r_id=${reception_id}`
                );
              }}
              reception_id={reception_id}
              status_code={status_code}
              handleClickChangeDetails={() => requestModule(KWANKGM04030A05)}
              setIsLoading={setIsLoading}
              callApi={requestModule}
              guarantor_info={guarantor_info}
              is_secured={is_secured}
              is_unsecured={is_unsecured}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
            />
          </Route>
          {/* 辞退時：KWANKGM04040_借入申込完了 */}
          {/* NOTE 借入申込確認画面(2400,2500,2600,2700)で辞退した時の辞退完了画面を兼ねる */}
          <Route exact path="/reception/:reception_cd/:reception_id/(2400|2500|2600|2700)/declined">
            <DeclineLoanApplication
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              is_staff={is_staff}
              is_loading={is_loading}
            />
          </Route>
          {/* KDANKGM05010_契約書内容確認画面 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(3500|3600|3700|3800|3900)">
            <ContractContentConfirm
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              reception_sub_cd={reception_sub_cd}
              sign_info={sign_info}
              guarantors_num={guarantors_num}
              guarantor_info={guarantor_info}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              is_signed={is_signed}
              handleDecline={() => requestModule(KDANKGM05010A01)}
              handleExecution={() => requestModule(KDANKGM05010A02)}
              callApi={requestModule}
              is_loading={is_loading}
              is_checked_contract_document={is_checked_contract_document}
              is_secured={is_secured}
              is_unsecured={is_unsecured}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
              info_notice={info_notice_contract_confirm}
              is_active_decline_btn={is_active_decline_btn}
              is_signer={is_signer}
            />
          </Route>
          {/* 本審査結果確認 */}
          <Route exact path="/reception/:reception_cd/:reception_id/3000">
            <ConfirmationOfMainExaminationResults
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true}
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              moveNextStep={() => moveStepNav(2)}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              display_status={display_status}
              show_error_nav={has_valid_error || show_error_nav}
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              reception_sub_cd={reception_sub_cd}
              guarantor_info={guarantor_info}
              callApi={requestModule}
              is_secured={is_secured}
              is_unsecured={is_unsecured}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
            />
          </Route>
          {/* KWANKGM04080_契約申込確認 */}
          <Route exact path="/reception/:reception_cd/:reception_id/3000/confirm">
            <ContractApplicationConfirmation
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              reception_id={reception_id}
              movePrevStep={() => moveStepNav(1)}
              moveNextStep={() => moveStepNav(3)}
              is_loading={is_loading}
              display_status={display_status}
              status_code={status_code}
              contractExecution={() => requestModule(KWANKGM04080A01)}
              refusalExecution={() => requestModule(KWANKGM04080A02)}
              contract_info={contract_info}
            />
          </Route>
          {/* 実行時：KWANKGM04090_契約申込完了 */}
          <Route exact path="/reception/:reception_cd/:reception_id/3000/finish">
            <ContractApplicationFinish
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              is_staff={is_staff}
              is_loading={is_loading}
            />
          </Route>
          {/* 辞退時：KWANKGM04090_契約申込完了 */}
          <Route exact path="/reception/:reception_cd/:reception_id/3000/declined">
            <ContractApplicationDeclined
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              is_staff={is_staff}
              is_loading={is_loading}
            />
          </Route>
          {/* KWANKGM00190_案件詳細（マイページ） */}
          <Route exact path="/reception/:reception_cd/:reception_id/4100">
            <SignatureComplete
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              reception_id={reception_id}
              reception_cd={reception_cd}
              reception_sub_cd={reception_sub_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              status_code={status_code}
              is_staff={is_staff}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              callApi={requestModule}
              guarantor_info={guarantor_info}
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
              agreement_info={agreement_info}
              sign_info={sign_info}
              is_secured={is_secured}
              is_unsecured={is_unsecured}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
              is_signer={is_signer}
            />
          </Route>

          {/* Note 以下、参照画面 */}
          {/* 1300, 1400, 91550 借入相談 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(1300|1400|91550)">
            <BorrowingConsultationReferencePreview
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              is_staff={is_staff}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              callApi={requestModule}
              guarantor_info={guarantor_info}
              agreement_info={agreement_info}
              status={status_code}
            />
          </Route>
          {/* 92050 事前審査結果確認（不承認） */}
          <Route exact path="/reception/:reception_cd/:reception_id/92050">
            <PreliminaryExaminationResultConfirmationDisapproval
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true}
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              opened_mypage={opened_mypage}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              display_status={display_status}
              show_error_nav={has_valid_error || show_error_nav}
              guarantor_info={guarantor_info}
            />
          </Route>
          {/* 2900, 3100, 3400, 93050 借入申込以降の参照画面 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(2900|3100|3400|93050)">
            <AfterLoanApplication
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
              ident_lv1_cd={ident_lv1_cd}
              ident_lv2_cd={ident_lv2_cd}
              ident_lv3_cd={ident_lv3_cd}
              reception_sub_cd={reception_sub_cd}
              guarantors_num={guarantors_num}
              guarantor_info={guarantor_info}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              callApi={requestModule}
              is_loading={is_loading}
              is_staff={is_staff}
              is_secured={is_secured}
              is_unsecured={is_unsecured}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
            />
          </Route>
          {/* マスク画面 */}
          <Route
            exact
            path="/reception/:reception_cd/:reception_id/:status_code/mask/:shelf_cd/:target_index"
          >
            <MaskImage
              shelf_info={{
                shelf_info_a: shelf_info_a,
                shelf_info_b: shelf_info_b,
                shelf_info_c: shelf_info_c,
                shelf_info_d: shelf_info_d,
                shelf_info_e: shelf_info_e,
                shelf_info_f: shelf_info_f,
                shelf_info_g: shelf_info_g,
                shelf_info_h: shelf_info_h,
                shelf_info_i: shelf_info_i,
                shelf_info_j: shelf_info_j,
                shelf_info_k: shelf_info_k,
                shelf_info_aa: shelf_info_aa,
                shelf_info_ab: shelf_info_ab,
                shelf_info_ac: shelf_info_ac,
                shelf_info_ad: shelf_info_ad,
                shelf_info_ae: shelf_info_ae,
                shelf_info_af: shelf_info_af,
                shelf_info_ag: shelf_info_ag,
                shelf_info_ah: shelf_info_ah,
                shelf_info_ai: shelf_info_ai,
                shelf_info_aj: shelf_info_aj,
                shelf_info_ak: shelf_info_ak,
                shelf_info_al: shelf_info_al,
                shelf_info_am: shelf_info_am,
                shelf_info_an: shelf_info_an,
                shelf_info_ao: shelf_info_ao,
                shelf_info_ap: shelf_info_ap,
                shelf_info_aq: shelf_info_aq,
                shelf_info_ar: shelf_info_ar,
                shelf_info_as: shelf_info_as,
                shelf_info_at: shelf_info_at,
                shelf_info_au: shelf_info_au,
                shelf_info_av: shelf_info_av,
                shelf_info_aw: shelf_info_aw,
                shelf_info_ax: shelf_info_ax,
                shelf_info_ay: shelf_info_ay,
                shelf_info_az: shelf_info_az,
                shelf_info_ba: shelf_info_ba,
                shelf_info_bb: shelf_info_bb,
                shelf_info_bc: shelf_info_bc,
                shelf_info_bd: shelf_info_bd,
                shelf_info_be: shelf_info_be,
                shelf_info_bf: shelf_info_bf,
                shelf_info_bg: shelf_info_bg,
                shelf_info_bh: shelf_info_bh,
                shelf_info_bi: shelf_info_bi,
              }}
              setShelfInfo={{
                setShelfInfoA: setShelfInfoA,
                setShelfInfoB: setShelfInfoB,
                setShelfInfoC: setShelfInfoC,
                setShelfInfoD: setShelfInfoD,
                setShelfInfoE: setShelfInfoE,
                setShelfInfoF: setShelfInfoF,
                setShelfInfoG: setShelfInfoG,
                setShelfInfoH: setShelfInfoH,
                setShelfInfoI: setShelfInfoI,
                setShelfInfoJ: setShelfInfoJ,
                setShelfInfoK: setShelfInfoK,
                setShelfInfoAA: setShelfInfoAA,
                setShelfInfoAB: setShelfInfoAB,
                setShelfInfoAC: setShelfInfoAC,
                setShelfInfoAD: setShelfInfoAD,
                setShelfInfoAE: setShelfInfoAE,
                setShelfInfoAF: setShelfInfoAF,
                setShelfInfoAG: setShelfInfoAG,
                setShelfInfoAH: setShelfInfoAH,
                setShelfInfoAI: setShelfInfoAI,
                setShelfInfoAJ: setShelfInfoAJ,
                setShelfInfoAK: setShelfInfoAK,
                setShelfInfoAL: setShelfInfoAL,
                setShelfInfoAM: setShelfInfoAM,
                setShelfInfoAN: setShelfInfoAN,
                setShelfInfoAO: setShelfInfoAO,
                setShelfInfoAP: setShelfInfoAP,
                setShelfInfoAQ: setShelfInfoAQ,
                setShelfInfoAR: setShelfInfoAR,
                setShelfInfoAS: setShelfInfoAS,
                setShelfInfoAT: setShelfInfoAT,
                setShelfInfoAU: setShelfInfoAU,
                setShelfInfoAV: setShelfInfoAV,
                setShelfInfoAW: setShelfInfoAW,
                setShelfInfoAX: setShelfInfoAX,
                setShelfInfoAY: setShelfInfoAY,
                setShelfInfoAZ: setShelfInfoAZ,
                setShelfInfoBA: setShelfInfoBA,
                setShelfInfoBB: setShelfInfoBB,
                setShelfInfoBC: setShelfInfoBC,
                setShelfInfoBD: setShelfInfoBD,
                setShelfInfoBE: setShelfInfoBE,
                setShelfInfoBF: setShelfInfoBF,
                setShelfInfoBG: setShelfInfoBG,
                setShelfInfoBH: setShelfInfoBH,
                setShelfInfoBI: setShelfInfoBI,
              }}
            />
          </Route>
        </Switch>
      </FixedValuesContext.Provider>
    </Router>
  );
};

if (document.getElementById('template')) {
  ReactDOM.render(<App />, document.getElementById('template'));
}
